module.exports = __webpack_public_path__ + "img/b837567.jpg";